<ng-container *transloco="let t">
  <app-page-template [showBreadcrumbs]="false">
    <div class="carousel-wrapper">
      <div class="carousel-wrapper__title-box">
        <div class="container align-items-center d-flex h-100">
          <h1 class="main-hero-title font-6xl light">
            {{t('live.results.race.header.title')}} </h1>
        </div>
      </div>
      <app-carousel [images]="[image]" [showGradient]="true"></app-carousel>
    </div>

    <ng-template [ngTemplateOutlet]="results"></ng-template>
  </app-page-template>

  <ng-template #results>
    <section class="upper-section-background">
      <div class="container padding-bottom-92 pt-62-32 pb-300-100">
        <div class="row row-cols-1">
          @if (liveEvents.length > 0) {
            <div>
              @for (liveEvent of liveEvents;track liveEvent) {
                <div>
                  <app-live-event [liveEvent]="liveEvent" [languages]="languages" [countries]="countries"/>
                </div>
              }
            </div>
          } @else {
            <app-empty-state-live/>
          }
        </div>
      </div>
    </section>
  </ng-template>
</ng-container>
